import { render } from "./InicioSuperAdmins.vue?vue&type=template&id=287cdf6a&scoped=true"
import script from "./InicioSuperAdmins.vue?vue&type=script&lang=js"
export * from "./InicioSuperAdmins.vue?vue&type=script&lang=js"

import "./InicioSuperAdmins.vue?vue&type=style&index=0&id=287cdf6a&lang=scss&scoped=true"

import exportComponent from "/Users/coolio/Documents/proyectos/karga/backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287cdf6a"]])

export default __exports__